// extracted by mini-css-extract-plugin
export default {"accordionTable":"accordionTable___2hGMC","accordionTableHead":"accordionTableHead___3f-Io"};